<template>
  <div class="text-xs-center">
    <v-bottom-sheet :value="processState.show" :hide-overlay="true" width="100% !important">
      <v-card class="processCard">
        <v-layout row align-center class="processLayout">
          <div class="processJobs">
            <div class="processJob" v-for="process in processState.processes" :key="process.id" @click="renderContext($event, process)">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div class="processContent" v-on="on">
                    <div>
                      <v-icon :color="getReportFormat(process.fileFormat).color">{{ getReportFormat(process.fileFormat).icon }}</v-icon>
                      {{ getTrim(process.name) }}
                      <v-icon color="green" v-if="process.init === 1">mdi-check-circle</v-icon>
                      <div v-if="process.downloading">
                        <v-progress-linear :indeterminate="true" color="purple"></v-progress-linear>
                      </div>
                      <div v-else>
                        <v-progress-linear :indeterminate="true" v-if="process.init === 0"></v-progress-linear>
                        <v-progress-linear :value="100" color="red" v-else-if="process.init === 2"></v-progress-linear>
                      </div>
                    </div>
                  </div>
                </template>
                <span> {{ process.name }}</span>
              </v-tooltip>
            </div>
          </div>
          <div>
            <v-speed-dial v-model="fab" right open-on-hover :direction="direction">
              <template v-slot:activator>
                <v-btn v-model="fab" color="teal" small dark fab fixed right bottom>
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn fab dark small color="red" v-on="on" @click="closeProcessPnl" class="mr-12">
                    <v-icon dark>mdi-close-box</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn fab dark small color="cyan" v-on="on" @click="openHistoryPage" >
                    <v-icon>mdi-note-text</v-icon>
                  </v-btn>
                </template>
                <span>Show all</span>
              </v-tooltip>
            </v-speed-dial>
          </div>
        </v-layout>
      </v-card>
    </v-bottom-sheet>
    <v-menu
      :z-index="1000"
      offset-x
      v-model="showContextMenu"
      absolute
      :position-x="contextMenuX"
      :position-y="contextMenuY"
      :min-width="180"
      transition="no-transition"
      close-on-click
    >
      <v-list>
        <v-list-item v-if="selectedProcess && selectedProcess.init === 1" @click="doDownload">
          <v-list-item-action>
            <v-icon>mdi-download</v-icon>
          </v-list-item-action>
          <v-list-item-title>Download</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="selectedProcess && selectedProcess.init === 2" @click="doRetry">
          <v-list-item-action>
            <v-icon>mdi-refresh</v-icon>
          </v-list-item-action>
          <v-list-item-title>Retry</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="selectedProcess && selectedProcess.init === 2" @click="errorDialog = true">
          <v-list-item-action>
            <v-icon>mdi-eye</v-icon>
          </v-list-item-action>
          <v-list-item-title>Show Error</v-list-item-title>
        </v-list-item>
        <v-list-item @click="removeProcess">
          <v-list-item-action>
            <v-icon>mdi-close</v-icon>
          </v-list-item-action>
          <v-list-item-title>Close</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="errorDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Error Log</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <p v-if="selectedProcess">
            {{ selectedProcess.errorMsg }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { USER_RPT_PROCESS_CLOSE, USER_RPT_PROCESS_REMOVE, USER_RPT_PROCESS_DOWNLOADSTATUS } from '@/store/types'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { downloadPrompt } from '@/utils/file'

export default {
  data() {
    return {
      showContextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      selectedProcess: undefined,
      errorDialog: false,
      fab: false,
      direction: 'left'
    }
  },
  computed: {
    processState() {
      return this.$store.state.user.rptJob.rptProcess
    }
  },
  methods: {
    getTrim(value) {
      var val = String(value)
      if (val !== undefined && val.length > 37) {
        return val.substring(0, 34) + '...'
      }
      return val
    },
    getReportFormat(format) {
      format = format.toUpperCase()
      const result = reportFormat[format]
      if (result) {
        return result
      } else {
        return {
          icon: 'mdi-file-document',
          color: 'blue'
        }
      }
    },
    closeProcessPnl() {
      this.$store.commit(USER_RPT_PROCESS_CLOSE)
    },
    openHistoryPage() {
      this.$store.commit(USER_RPT_PROCESS_CLOSE)
      this.$router.push({ name: 'rptJobs' })
    },
    renderContext(e, process) {
      this.selectedProcess = process
      e.preventDefault()
      this.showContextMenu = false
      this.contextMenuX = e.clientX
      this.contextMenuY = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    removeProcess() {
      if (this.selectedProcess) {
        this.$store.commit(USER_RPT_PROCESS_REMOVE, this.selectedProcess.id)
      }
    },
    async doDownload() {
      if (this.selectedProcess && this.selectedProcess.init === 1) {
        const apiURI = this.$store.state.app.menu.rptDownload
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedProcess.id
            }
            this.$store.commit(USER_RPT_PROCESS_DOWNLOADSTATUS, {
              id: this.selectedProcess.id,
              downloading: true
            })

            const result = await this.$http.get(expandURI(apiURI, expand), {
              responseType: 'blob'
            })
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            downloadPrompt(blob, filename)

            this.$store.commit(USER_RPT_PROCESS_DOWNLOADSTATUS, {
              id: this.selectedProcess.id,
              downloading: false
            })

            // After download, remove the process
            this.removeProcess()
            this.$store.dispatch('getReportsCount')
          } catch (err) {
            const { data } = err.response
            if (data) {
              // As the request is requesting blob, error has to be formatted back to json
              try {
                const errUrl = URL.createObjectURL(data)
                const errRes = await this.$http.get(errUrl)
                URL.revokeObjectURL(errUrl)
                if (errRes.data) {
                  this.notify(errRes.data)
                }
              } catch (err2) {
                //
              }
            }
            this.selectedJob.downloading = false
          }
        } else {
          this.notify('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async doRetry() {
      if (this.selectedProcess && this.selectedProcess.init === 2) {
        const apiURI = this.$store.state.app.menu.rptReprocess
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedProcess.id
            }
            await this.$http.post(expandURI(apiURI, expand))
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.notify('The request failed because it is trying to execute an invalid API url.')
        }
      }
    }
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
.processCard {
  min-height: 62px;
  .processLayout {
    height: 60px;
    .processJobs {
      display: inline-block;
      width: 100%;
      height: 100%;
      .processJob {
        display: inline-block;
        vertical-align: top;
        padding: 10px;
        height: 100%;
        min-width: 250px;
        max-width: 300px;
        border-right: 1px dotted;
        &:hover {
          cursor: pointer;
          background: #f5f5f5;
        }
        .processContent {
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
        .v-progress-linear {
          margin: 0.8rem 0 0 0;
        }
      }
    }
  }
}
.actionBtn {
  width: 15%;
  justify-content: center;
  align-items: center;
}
</style>
